import { GET_ASSESSMENTS_SUCCESS, GET_ASSESSMENT_SUCCESS } from '../actions/assessmentsActionTypes';

const initialAssessmentState = {
  answers: {},
  facilitators: [{
    name: '',
    title: '',
  }],
  participants: [{
    name: '',
    title: '',
  }],
  wastageCalculator: [{ medication: '' }],
  section: '1', // TO DO: remove placeholder!! let's be better at handling errors instead.
};

export default function list(state = {}, action) {
  switch (action.type) {
    case GET_ASSESSMENTS_SUCCESS: {
      const newObj = {};
      action.assessments.forEach((assessment) => {
        newObj[assessment.id] = state[assessment.id]
          ? {
            ...state[assessment.id], // don't overwrite a previous deep response
            ...assessment,
          } : {
            ...initialAssessmentState, // fill in any fields missing from the database response
            ...assessment,
          };
      });
      return {
        ...state,
        ...newObj,
      };
    }
    case GET_ASSESSMENT_SUCCESS:
      return {
        ...state,
        [action.assessment.id]: {
          ...initialAssessmentState, // fill in any fields missing from the database response
          ...action.assessment,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/assessmentsReducer.js